import { useState, useEffect } from "react";
import { HSCodeTree, ClassificationResult } from "./HSCodeTree";
import { hsLookupService } from "../Services/HSLookup";

export const HSLookup = () => {
  const [hsCode, setHsCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<ClassificationResult | null>(() => {
    const saved = localStorage.getItem('hsLookupResult');
    return saved ? JSON.parse(saved) : null;
  });
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    localStorage.setItem('hsCode', hsCode);
  }, [hsCode]);

  useEffect(() => {
    if (result) {
      localStorage.setItem('hsLookupResult', JSON.stringify(result));
    }
  }, [result]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setResult(null);
    
    try {
      const cleanedCode = hsCode.replace(/\./g, '');
      if (cleanedCode.length !== 10) {
        setError("Invalid HS code - must be 10 digits");
        return;
      }
      
      const searchResult = hsLookupService.lookup(hsCode);
      if (!searchResult) {
        setError("Invalid HS code");
        return;
      }
      
      setResult(searchResult);
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
        HS Code Lookup
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="hsCode" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            HS Code
          </label>
          <input
            id="hsCode"
            value={hsCode}
            onChange={(e) => setHsCode(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 dark:border-gray-600 shadow-sm focus:border-indigo-500 dark:focus:border-indigo-400 focus:ring-indigo-500 dark:focus:ring-indigo-400 px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
            placeholder="Enter 10 digit HS classification"
          />
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className="w-full sm:w-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 dark:bg-indigo-700 hover:bg-indigo-700 dark:hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 disabled:opacity-50"
        >
          {isLoading ? "Looking up..." : "Lookup"}
        </button>
      </form>
      
      {error && (
        <div className="mt-4 text-red-600 dark:text-red-400">
          {error}
        </div>
      )}
      
      {result && <HSCodeTree result={result} />}
    </div>
  );
};

